"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleItem = void 0;
const common_util_1 = require("../util/common-util");
const EsText_1 = require("./EsText");
class ScheduleItem {
    constructor(scheduleId, dateStart, dateEnd, description) {
        this.id = 0;
        this.dayId = 0;
        this.locationId = 0;
        this.title = "";
        this.subtitle = "";
        this.speakerIds = [];
        this.trackIds = [];
        this.scheduleId = scheduleId;
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
        this.description = description;
    }
    static fromDto(scheduleId, scheduleItemDto) {
        const description = EsText_1.EsText.fromOptionalTextDto(scheduleItemDto.description);
        const scheduleItem = new ScheduleItem(scheduleId, scheduleItemDto.dateStart, scheduleItemDto.dateEnd, description);
        scheduleItem.id = scheduleItemDto.id;
        scheduleItem.dayId = scheduleItemDto.dayId;
        if (scheduleItemDto.locationId) {
            scheduleItem.locationId = scheduleItemDto.locationId;
        }
        if (scheduleItemDto.title) {
            scheduleItem.title = scheduleItemDto.title;
        }
        if (scheduleItemDto.subtitle) {
            scheduleItem.subtitle = scheduleItemDto.subtitle;
        }
        if (scheduleItemDto.speakerIds && !common_util_1.isEmptyArray(scheduleItemDto.speakerIds)) {
            scheduleItem.speakerIds = scheduleItemDto.speakerIds;
        }
        if (scheduleItemDto.trackIds && !common_util_1.isEmptyArray(scheduleItemDto.trackIds)) {
            scheduleItem.trackIds = scheduleItemDto.trackIds;
        }
        return scheduleItem;
    }
    toDto() {
        const resultDto = {
            id: this.id,
            dayId: this.dayId,
            title: this.title,
            dateStart: this.dateStart,
            dateEnd: this.dateEnd
        };
        if (this.locationId > 0) {
            resultDto.locationId = this.locationId;
        }
        if (this.title) {
            resultDto.title = this.title;
        }
        if (this.subtitle) {
            resultDto.subtitle = this.subtitle;
        }
        if (this.description.notEmpty) {
            resultDto.description = this.description.toOptionalTextDto();
        }
        if (!common_util_1.isEmptyArray(this.speakerIds)) {
            resultDto.speakerIds = this.speakerIds;
        }
        if (!common_util_1.isEmptyArray(this.trackIds)) {
            resultDto.trackIds = this.trackIds;
        }
        return resultDto;
    }
    dateStartAndEndEquals() {
        return this.dateStart === this.dateEnd;
    }
}
exports.ScheduleItem = ScheduleItem;
